// Truncate text on Suggested Articles, Suggested Events, etc
export default function truncateText(str, strLength) {
  return str.length > strLength ? str.substring(0, strLength) + '...' : str;
}
